import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getPermissions} from './getPermissions';

/**
 * Permission'ы редко меняются за сессию — кэшируем на 5 минут.
 * `enabled` по умолчанию true; компонент-консьюмер сам решает через
 * `useQuery({ ...opts, enabled })` нужно ли тянуть прямо сейчас.
 */
export const permissionsQueryOptions = () =>
  queryOptions({
    queryKey: keys.auth.permissions(),
    queryFn: getPermissions,
    staleTime: 5 * 60_000,
  });
